import React from 'react'

function Popup({ onClose }) {
    return (
        <div className="z-10 fixed top-0 left-0 w-full h-full bg-[rgba(0,0,0,0.6)] flex justify-center items-center" onClick={onClose}>
            <div className="bg-white p-[20px] rounded font-inter" onClick={(e) => e.stopPropagation()}>
                <h2 className="text-2xl text-center font-semibold">Thanks for Joining</h2>
                <p className="text-lg">You are now officially on Waitlist</p>
                <button className="mt-5" onClick={onClose}>Close</button>
            </div>
        </div>
    )
}

export default Popup